import { Link as LinkIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { i18n } from "@/i18n";
import { SectionCard } from "@/components/ui/section-card";

interface StatementLinkProps {
  enabled: boolean;
  url: string;
  onToggle: (checked: boolean) => void;
  onUrlChange: (url: string) => void;
}

export function StatementLink({ enabled, url, onToggle, onUrlChange }: StatementLinkProps) {
  return (
    <SectionCard className="cy:border cy:border-gray-200" >
      <div className="cy:space-y-1 cy:mb-4">
        <h3 className="cy:text-[18px] cy:font-semibold cy:text-foreground">{i18n.__( 'Link your statement', 'accessibility-widget' )}</h3>
        <p className="cy:text-sm cy:text-muted-foreground">
          {i18n.__( 'Already have an accessibility statement page? Link it here to make it accessible through the widget.', 'accessibility-widget' )}
        </p>
      </div>

      <div className="cy:flex cy:items-center cy:justify-between cy:gap-4">
        <span className="cy:text-[16px] cy:text-foreground">{i18n.__( 'Link statement on widget', 'accessibility-widget' )}</span>
        <Switch
          id="cy-toggle-link-statement"
          checked={enabled}
          onCheckedChange={onToggle}
        />
      </div>

      {enabled && (
        <div className="cy:mt-4 cy:space-y-1.5">
          <Label
            htmlFor="cy-statement-url"
            className="cy:text-[16px] cy:font-medium cy:text-foreground"
          >
            {i18n.__( 'Accessibility statement URL', 'accessibility-widget' )}
          </Label>
          <div className="cy:relative cy:max-w-xl">
            <Input
              id="cy-statement-url"
              value={url}
              onChange={(e) => onUrlChange(e.target.value)}
              placeholder={i18n.__( 'E.g., yoursite.com/accessibility', 'accessibility-widget' )}
              className="cy:w-full cy:border! cy:rounded! cy:h-[48px] cy:pl-10"
            />
            <LinkIcon className="cy:absolute cy:left-3 cy:top-1/2 cy:-translate-y-1/2 cy:text-gray-400 cy:w-5 cy:h-5" />
          </div>
        </div>
      )}
    </SectionCard>
  );
}
